import { render, staticRenderFns } from "./project-table.vue?vue&type=template&id=6c0dd8ae&scoped=true&"
import script from "./project-table.vue?vue&type=script&lang=js&"
export * from "./project-table.vue?vue&type=script&lang=js&"
import style0 from "./project-table.vue?vue&type=style&index=0&id=6c0dd8ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0dd8ae",
  null
  
)

export default component.exports